import Axios from "./axios";

const resource = "footers";

export default {
	get() {
		return Axios.get(`${resource}`);
	}
}